export default __webpack_public_path__ + "static/media/shopping-bag.ffc54a72.png";